import React, { useState } from 'react';
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import './LoginPage.css';
import WebChaterLogo from './WebChatterLogo2.png';
import { auth } from './firebase';

const faqs = [
  {
    question: "What is WebChatter?",
    answer: "WebChatter is a Chrome extension that lets you chat with the content of any webpage, PDF, or YouTube video using AI."
  },
  {
    question: "Does it support all browsers?",
    answer: "Currently, WebChatter is only available as a Chrome extension."
  },
  {
    question: "Can I interact with YouTube videos?",
    answer: "Yes! WebChatter reads closed captions and answers questions about the video content."
  },
  {
    question: "Can I save or download my chat?",
    answer: "Yes, you can save selected content and download chat history for later use."
  },
  {
    question: "Is my data secure?",
    answer: "Yes, we use secure authentication with Google and never store sensitive information."
  }
];

function LoginPage({ user }) {
  const [openFAQIndex, setOpenFAQIndex] = useState(null);

  const handleGoogleSignIn = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider).catch((error) => {
      console.error('Google Sign-In Error:', error.message);
    });
  };

  return (
    <div className="webchatter-wrapper">
      <header className="hero">
        <img src={WebChaterLogo} alt="WebChatter Logo" className="hero-logo" />
        {!user && (
          <button className="google-sign-in-button" onClick={handleGoogleSignIn}>
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" />
            Sign in with Google
          </button>
        )}
      </header>

      <section className="how-it-works">
        <h2>How it works</h2>
        <div className="how-grid">
          <div>
            <span role="img" aria-label="Install">🧩</span>
            <h3>Add to Chrome</h3>
            <p>Install WebChatter from the Chrome Web Store.</p>
          </div>
          <div>
            <span role="img" aria-label="Chat">💬</span>
            <h3>Chat with Content</h3>
            <p>Ask questions about the webpage, PDF, or video you're on.</p>
          </div>
          <div>
            <span role="img" aria-label="Save">💾</span>
            <h3>Save and Reuse</h3>
            <p>Store, organize, and revisit your chats and content.</p>
          </div>
        </div>
      </section>

      <section className="video-demo">
        <h2>Watch how it works</h2>
        <iframe
          width="100%"
          height="400"
          src="https://www.youtube.com/embed/o27s_Y2KTxA" // Replace with your demo video if available
          title="WebChatter Demo"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </section>

      <section className="faq-section">
        <h2>FAQs</h2>
        {faqs.map((faq, index) => (
          <div key={index} className={`faq-item ${openFAQIndex === index ? 'open' : ''}`}>
            <button
              className="faq-question"
              onClick={() => setOpenFAQIndex(openFAQIndex === index ? null : index)}
            >
              {faq.question}
            </button>
            {openFAQIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </section>

      <footer className="footer">
        <p>
        Visit our <a href="https://chromewebstore.google.com/detail/webchatter/efenphifgmfppobfedlpopbnbpnifpoi" target="_blank" rel="noopener noreferrer">Chrome Web Store Page</a>
        </p>
        <p>
          🌐 Developed by <a href="https://kimiascience.com" target="_blank" rel="noopener noreferrer">Kimia Science</a>
        </p>
      </footer>
    </div>
  );
}

export default LoginPage;
